import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { transformMessageText } from '../../utils/utils';

const IRTMessageBody = ({ content, messageId, messageImageUrl }) => (
  <Fragment>
    <div
      className="irt-body"
      dangerouslySetInnerHTML={{
        __html: transformMessageText({ content, messageId })
      }}
    />
    {messageImageUrl && <img alt="IRT Message" src={messageImageUrl} />}
  </Fragment>
);

IRTMessageBody.propTypes = {
  content: PropTypes.string,
  messageId: PropTypes.string,
  messageImageUrl: PropTypes.string
};

export default IRTMessageBody;
